
import createReducer from "../../../utils/createReducer";
import { fetchOnlineReviewActionType } from "../actionTypes";

const initialState = {
    isFetchingOnlineReviewData: false,
  OnlineReviewDataFetchingError: false,
    OnlineReviewData: []
}
const reducer = {
    [fetchOnlineReviewActionType.START_FETCHING_ONLINE_REVIEW_DATA]: (state) => {
        return {
            ...state,
            isFetchingOnlineReviewData: true,
            OnlineReviewDataFetchingError: false,
            OnlineReviewData: []
        };
    },
    [fetchOnlineReviewActionType.SUCCESS_FETCHING_ONLINE_REVIEW_DATA]: (state, action) => {
        const data = action.payload
        return {
            ...state,
            isFetchingOnlineReviewData: false,
            OnlineReviewDataFetchingError: false,
            OnlineReviewData: data
        };
    },

    [fetchOnlineReviewActionType.FAILURE_FETCHING_ONLINE_REVIEW_DATA]: (state) => {
        return {
            ...state,
            isFetchingOnlineReviewData: false,
            OnlineReviewDataFetchingError: true,
        };
    },
    [fetchOnlineReviewActionType.CLEAR_ONLINE_REVIEW_DATA]: (state) => {
        return {
            ...state,
            isFetchingOnlineReviewData: false,
            OnlineReviewDataFetchingError: false,
            OnlineReviewData: []
        };
    },
}
export default createReducer(initialState, reducer);